export type SubRuleModel={
    id:string;
    type:string
}


export class OtsDataSharingModal{
     policyId:string | number;
         cerReqId:string | number;
         policyScopeType:string;
         oldScopeId:string | number;
         oldRuleId:string | number;
         oldSubRules:any[];
         oldSubRuleIds:any[];
         otsScopeId:string | number;
         otsRuleId:string | number;
         otsSubRules:any[];
         otsSubRuleIds:any[];
         isEdit:boolean;
         isOts:boolean;
         constructor(){}
}
